import type { Company, User } from '@shared/schemas'
import type { PageProps, QueryDefinition } from '@/core'
import type { UsersFormValues } from './form'
import type { UsersVariables } from './variables'

export const USER_KEYS = {
  all: ['users'].join('/'),
  list: (role?: string) =>
    (role ? [...USER_KEYS.all, role] : [USER_KEYS.all]).join('/'),
  detail: (uid: string) => [...USER_KEYS.all, uid].join('/'),
  doctorSignature: (uid: string) =>
    [...USER_KEYS.all, 'doctors', uid, 'signature'].join('/'),
  doctors: {
    all: () => [...USER_KEYS.all, 'doctors'].join('/'),
    byCompany: (companyId: string) =>
      [...USER_KEYS.all, 'doctors', 'company', companyId].join('/'),
  },
}

export type UsersQueryDefinition = [
  QueryDefinition<'users', 'query', void, Array<User>>,
  QueryDefinition<'companies', 'query', void, Array<Company>>,
]

export const usersQueries: NonNullable<
  PageProps<UsersFormValues, UsersQueryDefinition, UsersVariables>['queries']
> = [
  {
    key: 'users',
    type: 'query',
    queryConfig: ({ get }) => {
      const role = get('state', 'role')
      return {
        endpoint: ['api', role ? `users?role=${role}` : 'users'],
        queryKey: [USER_KEYS.list(role)],
        enabled: true,
      }
    },
  },
  {
    key: 'companies',
    type: 'query',
    queryConfig: {
      endpoint: ['api', 'registry/companies'],
      queryKey: ['users/companies'],
      enabled: true,
    },
  },
]

export * from './signatures'
